import { jsx } from "react/jsx-runtime";
import { Avatar } from "@fluentui/react-components";
import { initialsOf } from "../internal/initials.js";
function OrgAvatar({
  name,
  logoUrl,
  size = 32,
  decorative = false,
  className
}) {
  return /* @__PURE__ */ jsx(
    Avatar,
    {
      shape: "square",
      color: "colorful",
      name,
      initials: initialsOf(name),
      size,
      className,
      ...logoUrl ? { image: { src: logoUrl } } : {},
      ...decorative ? { "aria-hidden": true } : {}
    }
  );
}
export {
  OrgAvatar
};
//# sourceMappingURL=org-avatar.js.map